/** List of all pill message types. */
const PillMessageType = {
  ERROR: 'error',
  INFO: 'info',
};

export default PillMessageType;
